/**
 * Marque / organisation affichée (en-têtes, défauts API, meta document).
 * Surcharge : REACT_APP_ORGANIZATION_NAME, REACT_APP_SITE_DESCRIPTION, REACT_APP_SUPPORT_EMAIL.
 */

const rawOrg = String(process.env.REACT_APP_ORGANIZATION_NAME || 'ENTREA').trim();

/** Nom court affiché (sidebar, portail membre, titres par défaut). */
export const ORGANIZATION_DISPLAY_NAME = rawOrg || 'ENTREA';

const rawSupport = String(process.env.REACT_APP_SUPPORT_EMAIL || 'support@urugandaplatform.com').trim();

/** E-mail support (page Support membre, lien mailto, mot de passe oublié). */
export const SUPPORT_EMAIL = rawSupport || 'support@urugandaplatform.com';

const rawDesc = String(process.env.REACT_APP_SITE_DESCRIPTION || '').trim();

/** Meta description (balise + og:description). */
export function getSiteMetaDescription() {
  if (rawDesc) return rawDesc;
  return `${ORGANIZATION_DISPLAY_NAME} — Gestion de l'association`;
}

/** Titre d’onglet par défaut (sans route spécifique). */
export function getDefaultDocumentTitle() {
  return ORGANIZATION_DISPLAY_NAME;
}

function setOrCreateMeta(attr, key, value) {
  if (typeof document === 'undefined') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

/**
 * Titre d’onglet + meta description + Open Graph + titre Apple web app.
 * @param {{ title: string, description: string, ogTitle?: string }} p
 */
export function applyPortalMetaTags({ title, description, ogTitle }) {
  if (typeof document === 'undefined') return;
  const og = String((ogTitle ?? title) || '').trim() || ORGANIZATION_DISPLAY_NAME;
  document.title = String(title || '').trim() || ORGANIZATION_DISPLAY_NAME;
  setOrCreateMeta('name', 'description', description);
  setOrCreateMeta('property', 'og:title', og);
  setOrCreateMeta('property', 'og:description', description);
  let apple = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!apple) {
    apple = document.createElement('meta');
    apple.setAttribute('name', 'apple-mobile-web-app-title');
    document.head.appendChild(apple);
  }
  apple.setAttribute('content', og);
}

/** Applique titre + meta dès le chargement du bundle (avant le premier rendu React). */
export function applyDocumentBranding() {
  applyPortalMetaTags({
    title: getDefaultDocumentTitle(),
    description: getSiteMetaDescription(),
    ogTitle: ORGANIZATION_DISPLAY_NAME,
  });
}
